module.exports = __webpack_public_path__ + "img/2-lg.e710d2c7.jpg";